import { render, staticRenderFns } from "./ModelToggle.vue?vue&type=template&id=b9abc904&lang=pug"
import script from "./ModelToggle.vue?vue&type=script&lang=ts"
export * from "./ModelToggle.vue?vue&type=script&lang=ts"
import style0 from "./ModelToggle.vue?vue&type=style&index=0&id=b9abc904&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports